module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.cc7343dc.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-bold-webfont.eot
// module id = 278
// module chunks = 0